/*@flow*/
import { useEffect, useState } from 'react';
import isObject from 'lib/t/isObject';
import uploadFiles from './uploadFiles';

function getNewItems(items, value) {
  // HACK: Sometimes the original items can be an array of strings.
  const urls = value.map((v) => (isObject(v) ? v.url : v));
  // Remove duplicates
  return items
    .map(({ filename, url }) => ({ name: filename, url }))
    .filter((v) => !urls.includes(v.url))
    .concat(value);
}

type RecordT = { [key: string]: any };
type Item = { url: string } & RecordT;

export default function useUploadedFiles(
  originalItems: Item[] = [],
  accepted: string[] = ['image/*']
): [Item[], boolean, (boolean) => void] {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [newItems, setItems] = useState([]);

  useEffect(() => {
    if (!isLoading) return;
    const onStart = () => setLoading(false);
    uploadFiles(onStart, accepted).then((items) => {
      setItems(getNewItems(items, originalItems));
    });
  }, [isLoading]);
  return [newItems, isLoading, setLoading];
}
